var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-pill",class:_vm.classes,style:({..._vm.colorStyle, ..._vm.linkStyle, ..._vm.sizeStyle}),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }